(function() {
  angular.module('chamchamBackstage', ['ngAnimate', 'ngCookies', 'ngTouch', 'ngSanitize', 'ngMessages', 'ngAria', 'ngResource', 'ui.router', 'ui.bootstrap', 'toastr', 'ngStorage']);

}).call(this);



(function() {
  angular.module('chamchamBackstage').service('webDevTec', function() {
    'ngInject';
    var data, getTec;
    data = [
      {
        'title': 'AngularJS',
        'url': 'https://angularjs.org/',
        'description': 'HTML enhanced for web apps!',
        'logo': 'angular.png'
      }, {
        'title': 'BrowserSync',
        'url': 'http://browsersync.io/',
        'description': 'Time-saving synchronised browser testing.',
        'logo': 'browsersync.png'
      }, {
        'title': 'GulpJS',
        'url': 'http://gulpjs.com/',
        'description': 'The streaming build system.',
        'logo': 'gulp.png'
      }, {
        'title': 'Jasmine',
        'url': 'http://jasmine.github.io/',
        'description': 'Behavior-Driven JavaScript.',
        'logo': 'jasmine.png'
      }, {
        'title': 'Karma',
        'url': 'http://karma-runner.github.io/',
        'description': 'Spectacular Test Runner for JavaScript.',
        'logo': 'karma.png'
      }, {
        'title': 'Protractor',
        'url': 'https://github.com/angular/protractor',
        'description': 'End to end test framework for AngularJS applications built on top of WebDriverJS.',
        'logo': 'protractor.png'
      }, {
        'title': 'Bootstrap',
        'url': 'http://getbootstrap.com/',
        'description': 'Bootstrap is the most popular HTML, CSS, and JS framework for developing responsive, mobile first projects on the web.',
        'logo': 'bootstrap.png'
      }, {
        'title': 'Angular UI Bootstrap',
        'url': 'http://angular-ui.github.io/bootstrap/',
        'description': 'Bootstrap components written in pure AngularJS by the AngularUI Team.',
        'logo': 'ui-bootstrap.png'
      }, {
        'title': 'Sass (Node)',
        'url': 'https://github.com/sass/node-sass',
        'description': 'Node.js binding to libsass, the C version of the popular stylesheet preprocessor, Sass.',
        'logo': 'node-sass.png'
      }, {
        'title': 'CoffeeScript',
        'url': 'http://coffeescript.org/',
        'description': 'CoffeeScript, \'a little language that compiles into JavaScript\'.',
        'logo': 'coffeescript.png'
      }
    ];
    getTec = function() {
      return data;
    };
    this.getTec = getTec;
  });

}).call(this);



(function() {
  angular.module('chamchamBackstage').directive('acmeNavbar', function() {
    var NavbarController, directive;
    NavbarController = function(admin, $localStorage, $state) {
      'ngInject';
      var vm;
      vm = this;
      vm.getIsLoggedIn = function() {
        return admin.getIsLoggedIn();
      };
      vm.logout = function() {
        $localStorage.userData = null;
        admin.clear();
        return $state.go('home');
      };
    };
    return directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      scope: {
        creationDate: '='
      },
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };
  });

}).call(this);



(function() {
  angular.module('chamchamBackstage').directive('acmeMalarkey', function() {
    var MalarkeyController, directive, linkFunc;
    MalarkeyController = function($log, githubContributor) {
      'ngInject';
      var activate, getContributors, vm;
      vm = this;
      activate = function() {
        return getContributors().then(function() {
          $log.info('Activated Contributors View');
        });
      };
      getContributors = function() {
        return githubContributor.getContributors(10).then(function(data) {
          vm.contributors = data;
          return vm.contributors;
        });
      };
      vm.contributors = [];
      activate();
    };
    linkFunc = function(scope, el, attr, vm) {
      var typist, watcher;
      watcher = void 0;
      typist = malarkey(el[0], {
        typeSpeed: 40,
        deleteSpeed: 40,
        pauseDelay: 800,
        loop: true,
        postfix: ' '
      });
      el.addClass('acme-malarkey');
      angular.forEach(scope.extraValues, function(value) {
        typist.type(value).pause()["delete"]();
      });
      watcher = scope.$watch('vm.contributors', function() {
        angular.forEach(vm.contributors, function(contributor) {
          typist.type(contributor.login).pause()["delete"]();
        });
      });
      scope.$on('$destroy', function() {
        watcher();
      });
    };
    return directive = {
      restrict: 'E',
      scope: {
        extraValues: '='
      },
      template: '&nbsp;',
      link: linkFunc,
      controller: MalarkeyController,
      controllerAs: 'vm'
    };
  });

}).call(this);



(function() {
  angular.module('chamchamBackstage').service('kpi', function($http, config, admin, $localStorage) {
    'ngInject';
    var adminLogin, checkIn, configData;
    configData = config.getData();
    adminLogin = function(account, validator) {
      var params;
      params = {
        platform: 'kono',
        account: account,
        validator: validator
      };
      return $http.post(configData.apiUrl + "/admin/hotels/cham_cham/login", params).success(function(userData) {
        admin.setIsLoggedIn(true);
        admin.setToken(userData.token);
        return $localStorage.userData = userData;
      }).error(function() {
        return console.log('login fail');
      });
    };
    this.adminLogin = adminLogin;
    checkIn = function(roomNumber, nickname, startDate, endDate) {
      var params;
      params = {
        room_number: roomNumber,
        nickname: nickname,
        begin_at: startDate,
        end_at: endDate,
        token: admin.getToken()
      };
      return $http.post(configData.apiUrl + "/admin/hotels/cham_cham/users", params);
    };
    this.checkIn = checkIn;
  });

}).call(this);



(function() {
  angular.module('chamchamBackstage').factory('githubContributor', function($log, $http) {
    'ngInject';
    var apiHost, getContributors, service;
    apiHost = 'https://api.github.com/repos/Swiip/generator-gulp-angular';
    getContributors = function(limit) {
      var getContributorsComplete, getContributorsFailed;
      if (limit == null) {
        limit = 30;
      }
      getContributorsComplete = function(response) {
        return response.data;
      };
      getContributorsFailed = function(error) {
        $log.error('XHR Failed for getContributors.\n' + angular.toJson(error.data, true));
      };
      return $http.get(apiHost + '/contributors?per_page=' + limit).then(getContributorsComplete)["catch"](getContributorsFailed);
    };
    return service = {
      apiHost: apiHost,
      getContributors: getContributors
    };
  });

}).call(this);



(function() {
  angular.module('chamchamBackstage').service('config', function() {
    'ngInject';
    var data, getData;
    data = window.__env;
    getData = function() {
      return data;
    };
    this.getData = getData;
  });

}).call(this);



(function() {
  angular.module('chamchamBackstage').service('admin', function($http, config, $localStorage) {
    'ngInject';
    var Admin;
    Admin = function() {
      this._isLoggedIn = !!$localStorage.userData;
      this.setIsLoggedIn = function(isLoggedIn) {
        return this._isLoggedIn = isLoggedIn;
      };
      this.getIsLoggedIn = function() {
        return this._isLoggedIn;
      };
      this.setToken = function(token) {
        return this._token = token;
      };
      this.getToken = function() {
        return this._token;
      };
      this.autoLogIn = function() {
        if (!!this._isLoggedIn) {
          return this._token = $localStorage.userData.token;
        }
      };
      this.clear = function() {
        this._token = null;
        return this._isLoggedIn = null;
      };
    };
    return new Admin;
  });

}).call(this);



(function() {
  angular.module('chamchamBackstage').controller('MainController', function($timeout, webDevTec, toastr) {
    'ngInject';
    var activate, getWebDevTec, showToastr, vm;
    vm = this;
    activate = function() {
      getWebDevTec();
      $timeout((function() {
        vm.classAnimation = 'rubberBand';
      }), 4000);
    };
    showToastr = function() {
      toastr.info('Fork <a href="https://github.com/Swiip/generator-gulp-angular" target="_blank"><b>generator-gulp-angular</b></a>');
      vm.classAnimation = '';
    };
    getWebDevTec = function() {
      vm.awesomeThings = webDevTec.getTec();
      angular.forEach(vm.awesomeThings, function(awesomeThing) {
        awesomeThing.rank = Math.random();
      });
    };
    vm.awesomeThings = [];
    vm.classAnimation = '';
    vm.creationDate = 1505889414120;
    vm.showToastr = showToastr;
    activate();
  });

}).call(this);



(function() {
  angular.module('chamchamBackstage').controller('LoginController', function($http, kpi, $state, admin) {
    'ngInject';
    var vm;
    vm = this;
    vm.loginError = false;
    vm.adminLogin = function() {
      var onAdminLoginError, onAdminLoginSuccess;
      onAdminLoginSuccess = function() {
        return $state.go('checkIn');
      };
      onAdminLoginError = function() {
        return vm.loginError = true;
      };
      return kpi.adminLogin(vm.account, vm.password).then(onAdminLoginSuccess, onAdminLoginError);
    };
    if (!!admin.getIsLoggedIn()) {
      $state.go('checkIn');
    }
  });

}).call(this);



(function() {
  angular.module('chamchamBackstage').controller('CheckInController', function($http, kpi, $state, admin) {
    'ngInject';
    var vm;
    vm = this;
    vm.datePickerFormat = 'yyyy-MM-dd';
    vm.isStartDateOpen = false;
    vm.startDateOptions = {
      dateDisabled: false,
      formatYear: 'yy',
      maxDate: new Date(2048, 5, 22),
      minDate: new Date(),
      startingDay: 1
    };
    vm.isEndDateOpen = false;
    vm.endDateOptions = {
      dateDisabled: false,
      formatYear: 'yy',
      maxDate: new Date(2048, 5, 22),
      minDate: new Date(),
      startingDay: 1
    };
    vm.setDateLimit = function() {
      if (!!vm.startDate) {
        vm.endDateOptions.minDate = vm.startDate;
      }
      if (!!vm.endDate) {
        return vm.startDateOptions.maxDate = vm.endDate;
      }
    };
    vm.checkInSuccess = false;
    vm.checkInError = false;
    vm.submit = function() {
      var endDate, onCheckInError, onCheckInSuccess, startDate;
      vm.checkInSuccess = false;
      vm.checkInError = false;
      if (!vm.startDate || !vm.endDate) {
        vm.checkInError = true;
        return;
      }
      startDate = vm.startDate.getTime() / 1000;
      endDate = vm.endDate.getTime() / 1000;
      onCheckInSuccess = function(res) {
        vm.checkInSuccess = true;
        vm.code = res.data.platform_uid;
        vm.roomNumber = null;
        vm.nickname = null;
        vm.startDate = null;
        return vm.endDate = null;
      };
      onCheckInError = function() {
        return vm.checkInError = true;
      };
      return kpi.checkIn(vm.roomNumber, vm.nickname, startDate, endDate).then(onCheckInSuccess, onCheckInError);
    };
    if (!admin.getIsLoggedIn()) {
      $state.go('login');
    }
  });

}).call(this);



(function() {
  angular.module('chamchamBackstage').run(function($log, admin) {
    'ngInject';
    $log.debug('runBlock end');
    return admin.autoLogIn();
  });

}).call(this);



(function() {
  angular.module('chamchamBackstage').config(function($stateProvider, $urlRouterProvider, $locationProvider) {
    'ngInject';
    $stateProvider.state('home', {
      url: '/',
      templateUrl: 'app/main/main.html',
      controller: 'MainController',
      controllerAs: 'main'
    }).state('login', {
      url: '/login',
      templateUrl: 'app/login/login.html',
      controller: 'LoginController',
      controllerAs: 'login'
    }).state('checkIn', {
      url: '/check-in',
      templateUrl: 'app/check_in/check_in.html',
      controller: 'CheckInController',
      controllerAs: 'checkIn'
    });
    $urlRouterProvider.otherwise('/');
    return $locationProvider.html5Mode(true);
  });

}).call(this);



(function() {
  angular.module('chamchamBackstage').constant('malarkey', malarkey).constant('moment', moment);

}).call(this);



(function() {
  angular.module('chamchamBackstage').config(function($logProvider, toastrConfig) {
    'ngInject';
    $logProvider.debugEnabled(true);
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = true;
    return toastrConfig.progressBar = true;
  });

}).call(this);



angular.module("chamchamBackstage").run(["$templateCache", function($templateCache) {$templateCache.put("app/check_in/check_in.html","<div class=container><div><acme-navbar></acme-navbar></div><div class=\"jumbotron text-center\"><p class=lead></p><p>開通使用者帳號</p><form class=form-horizontal ng-submit=checkIn.submit() role=form><div class=form-group><label class=\"col-sm-3 control-label\">房號</label><div class=col-sm-6><input type=text class=form-control ng-model=checkIn.roomNumber></div><div class=col-sm-3></div></div><div class=form-group><label class=\"col-sm-3 control-label\">稱呼</label><div class=col-sm-6><input type=text class=form-control ng-model=checkIn.nickname></div><div class=col-sm-3></div></div><div class=form-group><label class=\"col-sm-3 control-label\">起始日期</label><div class=col-sm-6><input type=text class=form-control uib-datepicker-popup={{checkIn.datePickerFormat}} ng-model=checkIn.startDate ng-change=checkIn.setDateLimit() is-open=checkIn.isStartDateOpen ng-focus=\"checkIn.isStartDateOpen = true\" datepicker-options=checkIn.startDateOptions close-text=close></div><div class=col-sm-3></div></div><div class=form-group><label class=\"col-sm-3 control-label\">結束日期</label><div class=col-sm-6><input type=text class=form-control uib-datepicker-popup={{checkIn.datePickerFormat}} ng-model=checkIn.endDate ng-change=checkIn.setDateLimit() is-open=checkIn.isEndDateOpen ng-focus=\"checkIn.isEndDateOpen = true\" datepicker-options=checkIn.endDateOptions close-text=close></div><div class=col-sm-3></div></div><div ng-show=checkIn.checkInSuccess><div class=col-sm-3></div><div class=\"col-sm-6 alert alert-success\">登入成功！兌換代碼： <strong>{{checkIn.code}}</strong></div><div class=col-sm-3></div></div><div ng-show=checkIn.checkInError><div class=col-sm-3></div><div class=\"col-sm-6 alert alert-danger\"><strong>開通失敗!<br></strong>請檢查欄位是否正確，或洽 Kono 工程人員</div><div class=col-sm-3></div></div><input type=submit value=開通帳號 class=\"btn btn-primary col-sm-offset-5\"></form><p></p></div></div>");
$templateCache.put("app/login/login.html","<div class=container><div><acme-navbar></acme-navbar></div><div class=\"jumbotron text-center\"><p class=lead></p><form class=form-horizontal ng-submit=login.adminLogin() role=form><div class=form-group><label class=\"col-sm-3 control-label\">Account</label><div class=col-sm-6><input type=text class=form-control ng-model=login.account></div><div class=col-sm-3></div></div><div class=form-group><label class=\"col-sm-3 control-label\">Password</label><div class=col-sm-6><input type=password class=form-control ng-model=login.password></div><div class=col-sm-3></div></div><div ng-show=login.loginError><div class=col-sm-3></div><div class=\"col-sm-6 alert alert-danger\"><strong>登入失敗!<br></strong>請檢查帳號密碼是否正確，或洽 Kono 工程人員</div><div class=col-sm-3></div></div><input type=submit value=登入 class=\"btn btn-primary col-sm-offset-5\"></form><p></p></div></div>");
$templateCache.put("app/main/main.html","<div class=container><div><acme-navbar></acme-navbar></div><div class=\"jumbotron text-center\"><h1>歡迎使用趣淘漫旅 X Kono 後台</h1><p class=lead><img class=main-logo src=assets/images/main_logo.svg><br></p></div></div>");
$templateCache.put("app/components/navbar/navbar.html","<nav class=\"navbar navbar-static-top navbar-inverse\"><div class=container-fluid><div class=navbar-header><a class=navbar-brand href=/ >趣淘漫旅 X Kono 後台</a></div><div class=\"collapse navbar-collapse\" id=bs-example-navbar-collapse-6><ul class=\"nav navbar-nav\"><li ng-hide=vm.getIsLoggedIn()><a ng-href=/login>登入</a></li><li ng-show=vm.getIsLoggedIn()><a ng-href=/check-in>開通</a></li><li ng-show=vm.getIsLoggedIn()><a class=logout ng-click=vm.logout()>登出</a></li></ul></div></div></nav>");}]);